import { makeStyles } from "tss-react/mui";
import { MiButton } from "@miplatform/components";
import { BUTTON_VARIANTS, TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { Box, Typography } from "@mui/material";

export function OptionSummaryMarkupForm({
  optionDetails,
  renderPriceSummary,
  isLoading,
  onBack,
  onSave = undefined,
}) {
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <Typography
          className={classes.optionName}
          variant={TYPOGRAPHY_VARIANTS.BODY1}
        >
          {`Option Name: `}
          <span className={classes.highlight}>{optionDetails?.name}</span>
        </Typography>
        <Box className={classes.optionActions}>
          <MiButton
            title="Close"
            variant={BUTTON_VARIANTS.OUTLINED}
            onClick={onBack}
            disabled={isLoading}
          />
          <MiButton
            title="Update Markup"
            variant={BUTTON_VARIANTS.CONTAINED}
            onClick={onSave}
            disabled
          />
        </Box>
      </Box>
      <Box>{renderPriceSummary()}</Box>
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(4),
  },
  optionActions: {
    display: "flex",
    gap: theme.spacing(2),
  },
  optionName: {
    fontWeight: theme.fontWeight.bold,
  },
  highlight: {
    color: theme.palette.primary.main,
  },
}));
